import gql from 'graphql-tag'

export default gql`mutation generateProjectClientInvoices($data: [ProjectInvoiceInput]!){
  generateProjectClientInvoices(data: $data)
}`